export default __webpack_public_path__ + "static/media/east-dir-btn.674d31ff.png";